import { required, urlValid } from "@/services/ValidatorService";
export const registerForm = {
  image: {
    value: "",
    props: {
      filled: true,
      dense: true,
      id: "Image",
      placeholder: "Url de la imagen",
      "persistent-hint": true,
      rules: [required, urlValid]
    }
  },
  description: {
    value: "",
    props: {
      filled: true,
      dense: true,
      id: "Description",
      placeholder: "Descripcion",
      "persistent-hint": true,
      rules: [required]
    }
  },
  branch: {
    value: "",
    props: {
      filled: true,
      dense: true,
      id: "branch",
      placeholder: "Sucursal",
      "persistent-hint": true,
      rules: [required]
    }
  }
};
